// extracted by mini-css-extract-plugin
export default {"page":"StaffProductPage_page__b-0am"};